import { Component, Inject } from '@angular/core';
import Env from '@ridango/core/env';
import { HelperService } from '../../shared/services/helper.service';

@Component({
    selector: 'gl-personalize-parent-page',
    templateUrl: './personalize-parent-page.component.html',
    styleUrls: ['./personalize-parent-page.component.scss']
})
export class PersonalizeParentPageComponent {
    constructor(
        @Inject('ENV') public env: Env,
        public helperService: HelperService
    ) {}
}
